import {
  type Command,
  defaultCommandCallbacks as defaultCallbacks,
  triggerCommandEvent,
} from '@sceneio/graphql-subscription-command-type'

import type { Ws } from '../types'
import { useSubscription } from './useRawSubscription'

// @ts-ignore
import CommandQuery from '@sceneio/graphql-queries/src/subscriptions/CommandSubscription.gql'

export function useCommandSubscription(
  opts?: Command.SubscriptionOpts<Ws.HookOptions['onErrors']>,
) {
  useSubscription<{ command: Command.CommandType }>(
    { query: CommandQuery },
    ({ data, errors }) => {
      if (errors) {
        console.warn('[ws:command:warn]', errors)
        opts?.onErrors && opts.onErrors(errors)
      }

      if (data === undefined) {
        return
      }

      const { name, arg, timestamp } = data.command

      // dispatch document event
      triggerCommandEvent(data.command)

      const { callbacks = {} } = opts ?? {}

      // user defined callback
      if (name in callbacks) {
        callbacks[name]?.(arg as never, timestamp)
        return
      }

      // default callback
      if (name in defaultCallbacks) {
        defaultCallbacks[name as keyof typeof defaultCallbacks](arg as never)
        return
      }

      console.warn('[ws:command:warn] Not implemented command: %s', name, arg)
    },
  )
}
